import { FETCH_REPORT_GROUP_REQUEST, FETCH_REPORT_GROUP_SUCCESS, FETCH_REPORT_GROUP_FAILURE } from './actions';

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const reportGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REPORT_GROUP_REQUEST:
            return { ...state, loading: true };
        case FETCH_REPORT_GROUP_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case FETCH_REPORT_GROUP_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default reportGroupReducer;
